export enum UserRolesEnum {
  SuperAdmin = '49ce5f0e-e434-4b84-b685-547cdf8259f9',
  Admin = '25e102f4-7ee1-4fca-9071-f16e03da237b',
  Requester = '12c57649-f88c-4c97-9a75-3e5ffef1b9d6'
}
